import React from 'react';
import { LineChart, Line, ResponsiveContainer } from 'recharts';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

const Sparkline = ({ data = [], color = '#10b981' }) => (
  <div className="h-8 w-20">
    <ResponsiveContainer>
      <LineChart data={data.map(v => ({ v }))}>
        <Line type="monotone" dataKey="v" stroke={color} strokeWidth={1.5} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  </div>
);

const KpiCard = ({ label, value, icon, trend = null, trendLabel = '', sparklineData = [], color = 'emerald' }) => {
  const trendIcon = trend > 0 ? <TrendingUp size={12} /> : trend < 0 ? <TrendingDown size={12} /> : <Minus size={12} />;
  const trendColor = trend > 0 ? 'text-emerald-500' : trend < 0 ? 'text-red-500' : 'text-surface-400';

  return (
    <div className="bg-white dark:bg-surface-800 rounded-2xl border border-surface-100 dark:border-surface-700 shadow-soft p-4 hover:shadow-md transition-all duration-200">
      <div className="flex items-start justify-between mb-2">
        <div className={`w-8 h-8 rounded-xl bg-${color}-50 dark:bg-${color}-900/20 flex items-center justify-center text-${color}-600 dark:text-${color}-400`}>
          {icon}
        </div>
        {sparklineData.length > 0 && <Sparkline data={sparklineData} color={color === 'emerald' ? '#10b981' : color === 'blue' ? '#3b82f6' : color === 'amber' ? '#f59e0b' : color === 'purple' ? '#8b5cf6' : color === 'rose' ? '#f43f5e' : color === 'cyan' ? '#06b6d4' : '#64748b'} />}
      </div>
      <p className="font-display font-bold text-xl text-surface-900 dark:text-white">{value}</p>
      <p className="text-[11px] text-surface-400 dark:text-surface-500 mt-0.5">{label}</p>
      {trend !== null && (
        <div className={`flex items-center gap-1 mt-1.5 text-[10px] font-semibold ${trendColor}`}>
          {trendIcon}
          <span>{trend > 0 ? '+' : ''}{trend}%</span>
          {trendLabel && <span className="text-surface-400 font-normal">düne göre</span>}
        </div>
      )}
    </div>
  );
};

export default KpiCard;
